// stub for @kid/enterprise-icon/icon/output/Icon.js
// 原始实现是 SVG 图标渲染组件；这里渲染一个占位 span，避免在私服不可达时阻塞构建
var React = require('react');

function Icon(props) {
    var rest = Object.assign({}, props);
    delete rest.id;
    delete rest.name;
    delete rest.icon;
    return React.createElement(
        'span',
        Object.assign(
            {
                className: ['kid-icon-stub', props && props.className].filter(Boolean).join(' '),
                style: Object.assign(
                    { display: 'inline-block', width: '1em', height: '1em' },
                    (props && props.style) || {}
                ),
            },
            rest
        )
    );
}

module.exports = Icon;
module.exports.default = Icon;
